import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable, of } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class StateService {


  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getStates(paramsObj: any) {
    let params = new HttpParams();

    if (paramsObj) {
      Object.keys(paramsObj).forEach(key => {
        const value = paramsObj[key];
        if (value !== null && value !== undefined && value !== '') {
          params = params.set(key, value);
        }
      });
    }
    const url = this.apiUrl + '/estamp/states';
    return this.http.get<any>(url, { params }).pipe(
      map((res: any) => ({ ...res, totalCount: res?.data?.length }))
    ).pipe(
      map((res: any) => ({
        ...res,
        totalCount: res.meta.total
      }))
    );
  }


  createState(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/estamp/state`, data);
  }

  updateState(id: string, data: any): Observable<any> {
    return this.http.patch(`${this.apiUrl}/estamp/state/${id}`, data);
  }

  deleteState(id: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/estamp/state/${id}`);
  }
}
